// extracted by mini-css-extract-plugin
module.exports = {"slide__box":"live_slide__box__mgZ5S","slider__item__container":"live_slider__item__container__22I1t"};